import _ from 'lodash';
import {FormikHelpers} from 'formik';

/**
 * 空白スペースで文字を区切る
 */
export const splitKeyword = (
  fieldName: string,
  inputValue: string,
  searchKeywords: [{text: string; id: number}],
  formikHelpers: FormikHelpers<any>
) => {
  // 半角・全角スペースで文字を区切る
  const _inputValue = inputValue.split(/[\x20\u3000]/);

  _inputValue.forEach((_value: string) => {
    if (!_.isEmpty(_value)) {
      searchKeywords.push({
        text: _value,
        id: searchKeywords.length + 1,
      });
    }
  });
  formikHelpers.setFieldValue(fieldName, '');
};

export const addKeywordOnSearch = (
  inputword: string,
  searchKeywords: [{text: string; id: number}],
  inputFieldName: string,
  searchKeywordsName: string,
  formikHelpers: FormikHelpers<any>
) => {
  const inputWord = inputword.trim();

  if (inputWord) {
    // 検索キーワードラベルを追加
    searchKeywords.push({
      text: inputWord,
      id: searchKeywords.length + 1,
    });
    formikHelpers.setFieldValue(searchKeywordsName, searchKeywords);

    formikHelpers.setFieldValue(inputFieldName, '');
  } else {
    return;
  }
};
